/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

/**
 * The FIT CRC-16, computed a nibble at a time from a 16-entry table.
 *
 * A FIT file carries two of them: one over the first 12 header bytes (only when
 * the header is 14 bytes long), and one over the header plus all data records.
 */
public class Crc {
    public var value: UShort = 0u
        private set

    public fun update(byte: Byte): UShort {
        value = update(value, byte)
        return value
    }

    public fun update(bytes: ByteArray, startIndex: Int = 0, endIndex: Int = bytes.size): UShort {
        var crc = value
        for (i in startIndex until endIndex) {
            crc = update(crc, bytes[i])
        }
        value = crc
        return crc
    }

    public fun reset() {
        value = 0u
    }

    public companion object {
        private val TABLE = intArrayOf(
            0x0000, 0xCC01, 0xD801, 0x1400, 0xF001, 0x3C00, 0x2800, 0xE401,
            0xA001, 0x6C00, 0x7800, 0xB401, 0x5000, 0x9C01, 0x8801, 0x4400,
        )

        private fun update(crc: UShort, byte: Byte): UShort {
            var c = crc.toInt() and 0xFFFF
            val b = byte.toInt() and 0xFF

            // Lower nibble, then upper nibble.
            var tmp = TABLE[c and 0xF]
            c = (c shr 4) and 0x0FFF
            c = c xor tmp xor TABLE[b and 0xF]

            tmp = TABLE[c and 0xF]
            c = (c shr 4) and 0x0FFF
            c = c xor tmp xor TABLE[(b shr 4) and 0xF]

            return c.toUShort()
        }

        public fun calculate(bytes: ByteArray, startIndex: Int = 0, endIndex: Int = bytes.size): UShort {
            var crc: UShort = 0u
            for (i in startIndex until endIndex) {
                crc = update(crc, bytes[i])
            }
            return crc
        }
    }
}
